import * as FormConst from 'constants/FormConst'
import PropTypes from 'prop-types'
import React from 'react'
import { isReadOnly } from 'utilities/JSUtil'
import './ToggleSwitch.scss'

/*
Toggle Switch Component
Note: id, checked and onChange are required for ToggleSwitch component to function. The props name, small, disabled
and optionLabels are optional.
Usage: <ToggleSwitch id='id' checked={value} onChange={checked => setValue(checked)}} />
*/

const ToggleSwitch = ({
  id,
  name,
  checked,
  onChange,
  options,
  small,
  disabled,
  label,
  ...props
}) => {

  let classes = 'form-input-value'

  let requiredLabel = undefined

  if (props.isrequired === 'true') {
    requiredLabel = '*'
  }

  function handleKeyPress(e) {
    if (e.keyCode !== 32) return;

    e.preventDefault();
    onChange(e);
  }

  return (
    <div id={props.id} className='form-input'>
      {label && <label htmlFor={props.name} className='form-input-label'>
        {label}{requiredLabel}
      </label>
      }

      <div className={classes}>
        <div className={'toggle-switch' + (small ? ' small-switch' : '')}>
          <input
            type='checkbox'
            name={name}
            className='toggle-switch-checkbox'
            id={id}
            checked={checked}
            onChange={(e) => onChange(e)}
            disabled={props.overridedisabledflag === 'true' ? false : (isReadOnly() || props.disabled)}
            {...props} />

          {id ? (
            <label
              id={id + '-switch-label'}
              className='toggle-switch-label'
              tabIndex={disabled ? -1 : 1}
              onKeyDown={(e) => handleKeyPress(e)}
              htmlFor={id}>
              <span
                id={id + '-switch-inner'}
                className={
                  disabled
                    ? 'toggle-switch-inner toggle-switch-disabled'
                    : 'toggle-switch-inner'
                }
                data-yes={options[0]}
                data-no={options[1]}
                tabIndex={-1} />
              <span
                id={id + '-switch-switch'}
                className={
                  disabled
                    ? 'toggle-switch-switch toggle-switch-disabled'
                    : 'toggle-switch-switch'
                }
                tabIndex={-1} />
            </label>
          ) : null}
        </div>

      </div>
    </div>
  )
}

// Set optionLabels for rendering.
ToggleSwitch.defaultProps = {
  options: FormConst.SWITCH_OPTIONS_YES_NO
};

ToggleSwitch.propTypes = {
  // id: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string,
  options: PropTypes.array,
  small: PropTypes.bool,
  // disabled: PropTypes.bool
}

export default ToggleSwitch
